import React from 'react'
import { connect } from 'react-redux'
import Banners from '../components/banners'

const mapStateToProps = (state) => ({
  ...state.banners
})

const mapDispatchToProps = dispatch => ({
  onCreate: payload => dispatch({type: 'BANNERS.CREATE', payload}),
  onUpdate: payload => dispatch({type: 'BANNERS.UPDATE', payload}),
  onDelete: payload => dispatch({type: 'BANNERS.DELETE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Banners)
